import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Box, FormControlLabel, Checkbox, IconButton, Tooltip as MuiTooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

const CostoLogisticoVentasBar = ({ selectedIndustries = [], onBarClick = () => {} }) => {
  const [infoOpen, setInfoOpen] = useState(false);

  const allLabels = [
    'Servicios logísticos', 
    'Automotriz', 
    'Manufactura', 
    'Alimentos', 
    'Construcción', 
    'Salud/Farmacéutica', 
    'Retail'
  ];

  const logisticCostData2023 = {
    'Servicios logísticos': 24,
    'Automotriz': 11,
    'Manufactura': 9,
    'Alimentos': 9,
    'Construcción': 7,
    'Salud/Farmacéutica': 8,
    'Retail': 6,
  };

  const logisticCostData2024 = {
    'Servicios logísticos': 25,
    'Automotriz': 12,
    'Manufactura': 10,
    'Alimentos': 10,
    'Construcción': 8,
    'Salud/Farmacéutica': 9,
    'Retail': 7,
  };

  const colorMap = {
    '2023': '#476A8E',
    '2024': '#A2AEBB',
  };

  const labels = selectedIndustries.length > 0 ? selectedIndustries : allLabels;
  const dataValues2023 = labels.map((label) => logisticCostData2023[label]);
  const dataValues2024 = labels.map((label) => logisticCostData2024[label]);

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: 'Costo Logístico (%) (2022)',
        data: dataValues2023,
        backgroundColor: colorMap['2023'],
      },
      {
        label: 'Costo Logístico (%) (2023)',
        data: dataValues2024,
        backgroundColor: colorMap['2024'],
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: 'top',
        labels: {
          font: {
            size: 12, // Tamaño reducido para la leyenda
          },
        },
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.raw}%`,
        },
      },
      datalabels: {
        color: '#000',
        font: {
          weight: 'bold',
          size: 10, // Tamaño reducido para las etiquetas
        },
        anchor: 'end',
        align: 'start',
        offset: -20,
        formatter: (value) => `${value}%`,
      },
    },
    layout: {
      padding: {
        top: 10,
        bottom: 10,
        left: 5,
        right: 5,
      },
    },
    scales: {
      x: {
        barPercentage: 0.5, // Reduce el ancho de las barras
        categoryPercentage: 0.7, // Reduce el espacio entre las categorías
        ticks: {
          font: {
            size: 10, // Tamaño reducido para los ticks del eje X
          },
        },
      },
      y: {
        beginAtZero: true,
        max: 30,
        ticks: {
          stepSize: 5,
          font: {
            size: 10, // Tamaño reducido para los ticks del eje Y
          },
        },
        title: {
          display: true,
          text: 'Porcentaje (%)',
        },
      },
    },
  };

  const handleBarClick = (industry) => {
    let updatedSelectedIndustries = [...selectedIndustries];
    if (updatedSelectedIndustries.includes(industry)) {
      updatedSelectedIndustries = updatedSelectedIndustries.filter((item) => item !== industry);
    } else {
      updatedSelectedIndustries.push(industry);
    }
    onBarClick(updatedSelectedIndustries);
  };

  const handleCheckboxChange = (industry) => {
    handleBarClick(industry);
  };

  const infoContent = {
    Analisis: 'En 2023, Servicios logísticos mantiene el costo logístico más alto, reflejando su alta inversión en operaciones. Automotriz, Manufactura y Alimentos presentan un ligero aumento, mientras que Construcción, Salud/Farmacéutica y Retail siguen con costos más bajos, mostrando mayor control en su gestión logística.',
    formula: 'Costo Logístico (%) = (Costo total de Servicios logísticos / Ventas totales) × 100',
    description: 'Esta gráfica ilustra el costo logístico como un porcentaje del total de ventas para diferentes sectores industriales. Este indicador permite analizar la eficiencia de los gastos logísticos en relación con los ingresos generados.',  };
  

  return (
    <div style={{ maxWidth: '700px', margin: '0 auto', height: '480px', padding: '20px' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <MuiTooltip title="Información de la gráfica">
          <IconButton onClick={() => setInfoOpen(true)}>
            <InfoIcon />
          </IconButton>
        </MuiTooltip>
      </Box>
      <Box display="flex" justifyContent="center" flexWrap="wrap" mb={2}>
        {allLabels.map((industry) => (
          <FormControlLabel
            key={industry}
            control={
              <Checkbox
                checked={selectedIndustries.includes(industry)}
                onChange={() => handleCheckboxChange(industry)}
                color="primary"
              />
            }
            label={industry}
          />
        ))}
      </Box>
      <div style={{ width: '100%', height: '350px' }}>
        <Bar data={chartData} options={options} />
      </div>
  
      <Dialog open={infoOpen} onClose={() => setInfoOpen(false)}>
        <DialogTitle>Información de la Gráfica</DialogTitle>
        <DialogContent>
        <p><strong>Análisis:</strong> {infoContent.Analisis}</p>
          <p><strong>Fórmula:</strong> {infoContent.formula}</p>
          <p><strong>Descripción:</strong> {infoContent.description}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInfoOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
  
};

export default CostoLogisticoVentasBar;
